const SNACKBAR_TIMEOUT = 10000

const COIN_CURRENCY = {
    usd: '$',
    btc: 'BTC'
}

export { SNACKBAR_TIMEOUT, COIN_CURRENCY }
